import React from 'react';
import { UtensilsCrossed, Image, Heart, Users, FileText, Mail } from 'lucide-react';
import { useAdminData } from './_helpers';

const Card = ({ label, value, Icon }) => (
  <div className="bg-white rounded-xl p-6 shadow-md">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-gray-500 text-sm">{label}</p>
        <p className="text-3xl font-bold">{value}</p>
      </div>
      <Icon className="text-[#C9A86C]" size={32} />
    </div>
  </div>
);

const Overview = () => {
  const [menu] = useAdminData('menu-items');
  const [gallery] = useAdminData('gallery');
  const [community] = useAdminData('community');
  const [users] = useAdminData('users');
  const [pages] = useAdminData('pages');
  const [subs] = useAdminData('newsletter-subscribers');

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
        <Card label="Menu Items" value={menu.length} Icon={UtensilsCrossed} />
        <Card label="Gallery Images" value={gallery.length} Icon={Image} />
        <Card label="Community Initiatives" value={community.length} Icon={Heart} />
        <Card label="Pages" value={pages.length} Icon={FileText} />
        <Card label="Newsletter Subscribers" value={subs.length} Icon={Mail} />
        <Card label="Admin Users" value={users.length} Icon={Users} />
      </div>
      <div className="bg-white rounded-xl p-6 shadow-md">
        <h3 className="text-lg font-bold mb-2">Welcome to Bricklane CMS</h3>
        <p className="text-gray-600 text-sm">
          Use the sidebar to manage every text, image, table, and configuration on the site:
          Hero slideshow, full pages (Story, Chef's Table, Community, Private Events, Contact, Menu categories),
          navigation, footer, newsletter copy & subscribers, plus all menu/gallery/restaurant info.
        </p>
      </div>
    </div>
  );
};

export default Overview;
